import { useState, useCallback } from 'react';

// Services

import OptionsService from '../services/options.service';

export default function GetStatesByCountry() {
    const [getStatesIsLoading, setGetStatesIsLoading] = useState(false);
    const [getStatesError, setGetStatesError] = useState(null);
    const [states, setStates] = useState([]);

    // Get the States by Country

    const handleGetStatesByCountry = useCallback(async (country) => {
        setGetStatesIsLoading(true);
        setGetStatesError(null);

        try {
            const statesRequest = await OptionsService.getStatesByCountry(country);

            setGetStatesIsLoading(false);
            setStates(statesRequest?.data?.data);
    
        } catch(error) {

            setGetStatesIsLoading(false);
            setGetStatesError(error.response?.data?.message || error.message);

        }
    }, []);

    return {
        getStatesIsLoading,
        getStatesError,
        states,
        handleGetStatesByCountry,
        setStates,
    }
}
